import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadCrumb } from '../../../store';
import { IconComponent } from '@teamfoster/sdk/icon';

interface IBreadCrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RouterLink],
})
export class BreadcrumbsComponent {
  readonly breadCrumbs = input<BreadCrumb[]>([]);

  get lastItems() {
    const breadCrumbs = this.breadCrumbs();
    if (!breadCrumbs || !breadCrumbs?.length) {
      return [];
    }
    return breadCrumbs.slice(Math.max(breadCrumbs.length - 3, 0));
  }
}
